module.exports = __webpack_public_path__ + "static/Hirsch-b7299e8778e2817ff9e27b3598872554.jpg";